import React from "react";

const Pricetag = ({
  width = 20,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.7758 3.67074L9.52836 3.63541L9.35161 3.81214L3.51736 9.64564L3.16374 9.99922L3.51735 10.3528L9.88185 16.7165L10.2354 17.0701L10.5889 16.7165L16.4224 10.883L16.5992 10.7063L16.5639 10.4588L15.7689 4.89005L15.7159 4.51875L15.3446 4.46574L9.7758 3.67074ZM9.35164 3.10457L16.1572 4.07738L17.1293 10.8837L10.4121 17.6009C10.4121 17.6009 10.4121 17.6009 10.4121 17.6009C10.3652 17.6477 10.3017 17.6741 10.2354 17.6741C10.1691 17.6741 10.1056 17.6477 10.0587 17.6009C10.0587 17.6009 10.0587 17.6009 10.0586 17.6009L2.63374 10.176C2.58688 10.1291 2.56055 10.0655 2.56055 9.99922C2.56055 9.93293 2.58688 9.86935 2.63374 9.82247L9.35164 3.10457ZM11.6488 8.58523C11.4611 8.39755 11.3558 8.14303 11.3558 7.87767C11.3558 7.74627 11.3817 7.61617 11.432 7.49478C11.4824 7.37339 11.5561 7.2631 11.649 7.17021C11.7419 7.07731 11.8522 7.00363 11.9736 6.95337C12.0951 6.90311 12.2252 6.87725 12.3566 6.87727C12.6219 6.87732 12.8764 6.98278 13.064 7.17046C13.2516 7.35814 13.357 7.61265 13.357 7.87802C13.3569 8.14339 13.2514 8.39787 13.0638 8.58548C12.8761 8.77309 12.6216 8.87846 12.3562 8.87841C12.0908 8.87837 11.8364 8.7729 11.6488 8.58523Z"
        stroke="#133345"
      />
    </svg>
  );
};

export default Pricetag;
